import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card, Nav } from "react-bootstrap";
import bladesLogo from "../../../../src/assets/blades-in-the-dark/logo-blades-in-the-dark.png";
import sectionDivider from "../../../../src/assets/blades-in-the-dark/banner-bitd.webp";
import "../../../index.css";
import { ContentContainer } from "../SessionSection";
import { useEffect } from "react";
import NavBITDCore from "./NavBITDCore";
import assassins from "../../../../src/assets/blades-in-the-dark/tile-crew-assassins.webp";
import bravos from "../../../../src/assets/blades-in-the-dark/tile-crew-bravos.webp";
import cult from "../../../../src/assets/blades-in-the-dark/tile-crew-cult.webp";
import hawkers from "../../../../src/assets/blades-in-the-dark/tile-crew-hawkers.webp";
import shadows from "../../../../src/assets/blades-in-the-dark/tile-crew-shadows.webp";
import smugglers from "../../../../src/assets/blades-in-the-dark/tile-crew-smugglers.webp";

const pageHeader = {
  color: "white",
  backgroundColor: "black",
  opacity: "0.7",
  marginTop: "20px",
  padding: "15px",
};
const cardStyle = {
  textAlign: "left",
  fontFamily: "Special Elite",
  backgroundColor: "rgba(0, 0, 0, .7) ",
  color: "white",
  marginBottom: "15px",
};

const section1Data = [
  {
    title: "ASSASSINS",
    text: (
      <div class="morkBorgFont morkBorgTitleText">
        <i>Killers for hire.</i>
        <br />
        <br />
        They execute “accidents,” disappearances, murders, and ransoms.
        <br />
        You’re professional murderers—death is your business. In Duskwall, this
        means extra trouble from the spirit bells and vengeful ghosts. Be
        prepared!
        <br />
        <br />
        <em>
          Do you have any scruples when it comes to who you kill? Is everyone
          fair game?
        </em>
        <br />
        <br />
      </div>
    ),
    image: {
      imagePath: assassins,
      altText: `Assassins: killers for hire.`,
      className: "imageLeft",
      imageCaption: "",
    },
  },
  {
    title: "BRAVOS",
    text: (
      <div class="morkBorgFont morkBorgTitleText">
        <i>Mercenaries and thugs.</i>
        <br />
        <br />
        They execute battles, extortion, sabotage, and smash & grabs.
        <br />
        Some crews plot and scheme, some crews sneak around, some crews get
        entangled with the occult—you fight. The fist and the blade are all you
        need.
        <br />
        <br />
        <em>Are you brutal thugs, savvy sell-swords, or ruthless gangsters?</em>
      </div>
    ),
    image: {
      imagePath: bravos,
      altText: `Bravos: mercenaries and thugs.`,
      className: "imageLeft",
      imageCaption: "",
    },
  },
  {
    title: "CULT",
    text: (
      <div class="morkBorgFont morkBorgTitleText">
        <i>Acolytes of a forgotten god.</i>
        <br />
        <br />
        They execute artifact acquisitions, auguries, consecration, and
        sacrifices.
        <br />
        You heard the secret voice calling in the darkness. You obeyed. You are
        its instrument—and the world shall bow before its glory, or burn.
        <br />
        <br />
        <em>
          Instead of hunting grounds, you have sacred sites that you use for
          your operations.
        </em>
      </div>
    ),
    image: {
      imagePath: cult,
      altText: `Cult: acolytes of a forgotten god.`,
      className: "imageLeft",
      imageCaption: "",
    },
  },
  {
    title: "HAWKERS",
    text: (
      <div class="morkBorgFont morkBorgTitleText">
        <i>Vice dealers.</i>
        <br />
        <br />
        They execute product procurement, covert sales, shows of force, and
        social events.
        <br />
        All of Doskvol craves escape. They can’t go outside... but they can turn
        to you.
        <br />
        <br />
        <em>
          What’s your product? Who’s your supplier? Where and how do you sell
          it?
        </em>
      </div>
    ),
    image: {
      imagePath: hawkers,
      altText: `Hawkers: vice dealers.`,
      className: "imageLeft",
      imageCaption: "",
    },
  },
  {
    title: "SHADOWS",
    text: (
      <div class="morkBorgFont morkBorgTitleText">
        <i>Thieves and spies.</i>
        <br />
        <br />
        They execute burglaries, espionage, robberies, and sabotage.
        <br />
        Everyone wants something that they can’t have. That’s where you come in.
        <br />
        <br />
        <em>
          Do you spy and steal primarily to serve your own interests, or do you
          sell your services to whoever will pay?
        </em>
      </div>
    ),
    image: {
      imagePath: shadows,
      altText: `Shadows: thieves and spies.`,
      className: "imageLeft",
      imageCaption: "",
    },
  },
  {
    title: "SMUGGLERS",
    text: (
      <div class="morkBorgFont morkBorgTitleText">
        <i>Contraband transporters.</i>
        <br />
        <br />
        They execute clandestine deliveries, territory control, and expeditions
        outside the city.
        <br />
        Illicit goods are the life-blood of Duskwall—both for those who consume
        them and those who profit from their taxation and criminalization.
        Smugglers keep the city alive.
        <br />
        <br />
        <em>
          What kind of contraband do you transport? Do you have any rules about
          what you will or won’t carry?
        </em>
      </div>
    ),
    image: {
      imagePath: smugglers,
      altText: `Smugglers: contraband transporters.`,
      className: "imageLeft",
      imageCaption: "",
    },
  },
];

const BITDCrewsCore = () => {
  useEffect(() => {
    document.body.style.backgroundImage = `url(${require("../../../../src/assets/blades-in-the-dark/mood-doskvol_street-scene-01.webp")})`;
    document.body.style.backgroundColor = "#000000";
    document.body.style.back = "fixed";
    document.body.style.backgroundRepeat = "no-repeat";
    document.body.style.backgroundAttachment = "fixed";
  }, []);

  return (
    <div>
      <Container>
        <Row>
          <Col>
            <div
              style={{
                backgroundColor: "transparent",
                fontFamily: "Orbitron",
              }}
            >
              <main role="main" className="inner cover text-center">
                <img
                  src={bladesLogo}
                  style={{ maxWidth: "200px" }}
                  alt="Blades in the Dark campaign"
                />
              </main>
              <div style={pageHeader}>
                <h1 className="cover-heading">
                  Blades in the Dark: Core Crews
                </h1>
                <p className="lead leadExtra">
                  <NavBITDCore />
                </p>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <Card style={cardStyle}>
              <img
                src={sectionDivider}
                style={{ maxHeight: "169px" }}
                alt="section divider"
              />
              <Card.Body>
                <Card.Text>
                  <ContentContainer data={section1Data} />
                </Card.Text>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BITDCrewsCore;
